import { createContext } from "react";
import type { AlertAction } from "rivals/components/app/Layout/Alerts/types";
import type { State } from "rivals/redux/alert/reducer";

export const AlertContext = createContext<State>({ alerts: [] });
export const AlertDispatchContext = createContext<React.Dispatch<AlertAction>>(
  () => {}
);
